import React, { useEffect, useState } from "react";
import { HashLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../common/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { authSelector } from "../../apps/auth";
import { deviceSelector, fetchCountOnlineDevices } from "../../apps/device";
import { io } from "socket.io-client";
import "./style.css";

const Home = () => {
  const navigate = useNavigate();
  const { user, token } = useSelector(authSelector);
  const { onlinedevices, total, currentlyWatchingPlaylistChannel, currentlyWatchingSingleChannel, currentlyWatchingLiveChannel, currentlyWatchingMovie, currentlyWatchingSeries, androidCount, appleCount, tvCount, appleTvCount, subscriptionCount, weeklyCount, monthlyCount, yearlyCount, lifetimeCount, onlineAndroidCount, onlineAppleCount, onlineTVCount, onlineAppleTVCount, androidSubscriptionCount, appleSubscriptionCount, androidTVSubscriptionCount, appleTVSubscriptionCount } = useSelector(deviceSelector);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [devices, setDevices] = useState(0);
  const [socket, setSocket] = useState(null);

  const [configObject] = useState({
    headers: {
      Authorization: "Bearer " + token,
    },
    params: {},
  });

  const callApi = async () => {
    try {
      await dispatch(fetchCountOnlineDevices({ ...configObject }));

    } catch (error) {
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      callApi();
    }, 2000);
  }, []);

  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_SOCKET_URL);

    setSocket(newSocket);

    // Listen for device count update
    newSocket.on("device:registered", () => {
      callApi();
    });

    newSocket.on("device:disconnected", () => {
      callApi();
    });

    newSocket.on("device:watching", () => {
      callApi();
    });

    newSocket.on("xtream:watching", () => {
      callApi();
    });

    // Cleanup on unmount
    return () => {
      newSocket.disconnect();
    };
  }, []);

  const data = [
    {
      name: "Total Devices",
      number: total,
      icon: "fa fa-mobile text-white",
      image: "totaldevices.png",
      url: "#"
    },
    {
      name: "Total Subscriptions",
      number: subscriptionCount,
      icon: "fa fa-mobile text-white",
      image: "totalsubscriptions.png",
      url: "#"
    },
    {
      name: "Online Devices",
      number: onlinedevices,
      icon: "fa fa-mobile text-white",
      image: "onlinedevices.png",
      url: "#"
    },
    {
      name: "Online Watching Playlist Channel",
      number: currentlyWatchingPlaylistChannel,
      icon: "fa fa-mobile text-white",
      image: "onlinewatchingplaylist.png",
      url: "#"
    },
    // {
    //   name: "Online Watching Single Channel ",
    //   number: currentlyWatchingSingleChannel,
    //   icon: "fa fa-mobile text-white",
    //   url: "#"
    // },
    {
      name: "Online Watching Live Channel",
      number: currentlyWatchingLiveChannel,
      icon: "fa fa-mobile text-white",
      image: "livechannel.png",
      url: "#"
    },
    {
      name: "Online Watching Live Series",
      number: currentlyWatchingSeries,
      icon: "fa fa-mobile text-white",
      image: "liveseries.png",
      url: "#"
    },
    {
      name: "Online Watching Movies",
      number: currentlyWatchingMovie,
      icon: "fa fa-mobile text-white",
      image: "watchingmovies.png",
      url: "#"
    },
  ];


  return (
    <>
      <Sidebar />
      <section>
        {
          loading ?
            <div className="spinner">
              <HashLoader color="#757575" size={75} loading={true} />
            </div>
            :
            <div className="card">
              <div className="card-body">
                <div className="container-fluid">
                  <div className="row">
                    {data && data.map((item, i) => (
                      <div className="col-xl-3 col-md-6 col-sm-12 mb-4 dashboard_card" key={i}>
                        <div className="stats_list h-100">
                          <div className="stat_box white_box position-relative p-4 h-100 shadow-sm rounded">
                            <Link to={item?.url} className="d-flex gap-3 align-items-start text-decoration-none text-dark">
                              <span className="d-inline-flex justify-content-center align-items-center">
                                <img src={require(`../../assets/images/${item?.image}`)} width="30" alt="icon" />
                              </span>
                              <div>
                                <h5 className="mb-1 fw-bold">{item.number}</h5>
                                <p className="mb-2">{item.name}</p>

                                {item.name === 'Total Devices' && (
                                  <div className="d-flex flex-wrap small text-muted">
                                    <div className="me-3"><img src={require(`../../assets/images/android.png`)} className="me-1" width="18" alt="icon" />{androidCount}</div>
                                    <div className="me-3"><img src={require(`../../assets/images/apple.png`)} className="me-1" width="18" alt="icon" />{appleCount}</div>
                                    <div className="me-3"><img src={require(`../../assets/images/androidtv.png`)} className="me-1" width="18" alt="icon" />{tvCount}</div>
                                    <div className="me-3"><img src={require(`../../assets/images/appletv.png`)} className="me-1" width="18" alt="icon" />{appleTvCount}</div>
                                  </div>
                                )}

                                {item.name === 'Total Subscriptions' && (
                                  <>
                                    <div className="d-flex flex-wrap small text-muted">
                                      <div className="me-3">L <b>{lifetimeCount}</b></div>
                                      <div className="me-3">Y <b>{yearlyCount}</b></div>
                                      <div className="me-3">M <b>{monthlyCount}</b></div>
                                      <div className="me-3">W <b>{weeklyCount}</b></div>
                                    </div>
                                    <div className="d-flex flex-wrap small text-muted">
                                      <div className="me-3"><img src={require(`../../assets/images/android.png`)} className="me-1" width="18" alt="icon" />{androidSubscriptionCount}</div>
                                      <div className="me-3"><img src={require(`../../assets/images/apple.png`)} className="me-1" width="18" alt="icon" />{appleSubscriptionCount}</div>
                                      <div className="me-3"><img src={require(`../../assets/images/androidtv.png`)} className="me-1" width="18" alt="icon" />{androidTVSubscriptionCount}</div>
                                      <div className="me-3"><img src={require(`../../assets/images/appletv.png`)} className="me-1" width="18" alt="icon" />{appleTVSubscriptionCount}</div>
                                    </div>
                                  </>
                                )}

                                {item.name === 'Online Devices' && (
                                  <div className="d-flex flex-wrap small text-muted">
                                    <div className="me-3"><img src={require(`../../assets/images/android.png`)} className="me-1" width="18" alt="icon" />{onlineAndroidCount}</div>
                                    <div className="me-3"><img src={require(`../../assets/images/apple.png`)} className="me-1" width="18" alt="icon" />{onlineAppleCount}</div>
                                    <div className="me-3"><img src={require(`../../assets/images/androidtv.png`)} className="me-1" width="18" alt="icon" />{onlineTVCount}</div>
                                    <div className="me-3"><img src={require(`../../assets/images/appletv.png`)} className="me-1" width="18" alt="icon" />{onlineAppleTVCount}</div>
                                  </div>
                                )}
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

        }

      </section>
    </>
  );
};
export default Home;
